<div>
<nx-pageTitle-box
  class="mb-3"
  [label]="getLabel()"
  [icon]="'icon-person'"
  [iconToolTip]="'core.user.profile.iconTooltip' | translate">
  <ng-template nxTemplate="tag">
    <p-tag
      [value]="(user?.enabled ? 'core.user.state.enabled' : 'core.user.state.disabled') | translate"
      [severity]="user?.enabled ? 'success' : 'danger'">
    </p-tag>
  </ng-template>
</nx-pageTitle-box>


  <!-- [activeIndex] einwegig: setzt den Eingangstab aus ?tab= (#735). Ein Tab-Wechsel des
       Nutzers laeuft rein in p-tabView zurueck und aendert die URL bewusst nicht. -->
  <p-tabView [scrollable]="true" [activeIndex]="activeTabIndex">
    <p-tabPanel [header]="'core.user.profile.tabs.general' | translate">
      <div class="flex flex-row gap-4 mt-2">
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'core.user.profile.userData.headline' | translate">
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.firstName' | translate">
          {{user?.firstName}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.lastName' | translate">
          {{user?.lastName}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.initials' | translate">
          {{user?.initials}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.email' | translate">
          {{user?.email}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.locations' | translate">
          {{ getUserLocations() }}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.userData.groups' | translate">
        {{ userGroups | join }}
      </nx-default-box>
      </div>
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'core.user.profile.licence.headline' | translate">
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'core.user.profile.licence.type' | translate">
          {{user?.licenceType?.name}}
        </nx-default-box>
        <ng-container>
          <nx-headline-box
            class="mt-2 "
            [label]="'core.user.profile.language.headlineBox.label' | translate">
            <ng-template nxTemplate="end">
              <nx-default-button
                (click)="editPreferredLanguage()"
                [tooltip]="'core.user.profile.editPreferredLanguage' | translate"
                [icon]="'icon-edit'"
                [style]="'light'">
              </nx-default-button>
            </ng-template>
          </nx-headline-box>
          <nx-default-box
            class="bg-white border-b border-gray"
            [label]="'core.user.profile.language.preferredLanguage' | translate">
            {{getPreferredLanguage() | translate}}
          </nx-default-box>
        </ng-container>
      </div>
    </div>
    </p-tabPanel>
    <p-tabPanel [header]="'core.user.profile.tabs.roles' | translate">

      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="flex-1 flex flex-row items-center ml-3 font-medium">
          {{'core.user.profile.roles.headline' | translate}}
        </div>
        <div class="flex-none flex flex-row justify-center items-center">
        </div>
        <div class="flex-1 flex flex-row justify-end items-center">
          <input
          pInputText
          type="text"
          (input)="$any(roleTable).filterGlobal($event.target?.['value'], 'contains')"
          class="p-inputtext p-component p-element mr-3"
        [placeholder]="'core.user.profile.roles.searchPlaceholder' | translate" />
        </div>
      </div>


      <p-table
        #roleTable
        [value]="usersRolesFiltered"
        [scrollable]="true"
        [paginator]="true"
        [(selection)]="selectedRoles"
        [rows]="15"
        [rowsPerPageOptions]="[15, 20, 50]"
        [totalRecords]="usersRolesFiltered?.length"
        [showCurrentPageReport]="true"
        [filterDelay]="200"
        [currentPageReportTemplate]="'core.user.profile.roles.pageReport' | translate"
        [globalFilterFields]="['label']"
        [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>{{'core.user.profile.roles.table.name' | translate}}</th>
            <th>{{'core.user.profile.roles.table.inheritedFrom' | translate}}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
          <tr>
            <td>
              <p-tableCheckbox [value]="role" [disabled]="role.isInherited" ></p-tableCheckbox>
            </td>
            <td>{{role.label}}</td>
            <td>{{role.inheritedFrom ? (role.inheritedFrom | join) : "-"}}</td>
            <td class="text-right">
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2" class="emptyMessage">{{'core.user.profile.roles.emptyMessage' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <!-- #735: Notification-Einstellungen. pTemplate="content" statt ng-content, damit die
         Katalog-Query erst beim Oeffnen des Tabs feuert — p-tabPanel rendert ng-content
         unbedingt und blendet nur per [hidden] aus. -->
    <p-tabPanel [header]="'core.user.profile.tabs.notifications' | translate">
      <ng-template pTemplate="content">
        <app-notification-settings-list></app-notification-settings-list>
      </ng-template>
    </p-tabPanel>

  </p-tabView>

